/* Pagina de produto: ordem e blocos por baixo do botao de compra.
   Ordem final: botao -> linha de expedicao -> icones de pagamento -> aviso.
   Acrescenta tambem a linha de avaliacoes por cima do titulo. */
(function () {
  /* Nota e numero de opinioes indicados pelo Diogo.
     Para os alterar, muda so estas duas linhas. */
  var RATING = '4,7/5';
  var REVIEWS = 'na podstawie ponad 2500 opinii';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function shipDate() {
    var d = new Date();
    d.setDate(d.getDate() + 1);
    return pad(d.getDate()) + '/' + pad(d.getMonth() + 1);
  }

  /* Os SVGs dos icones de pagamento aparecem duas vezes na pagina (carrinho
     e pagina de produto) e partilham os mesmos ids de gradiente. O primeiro
     fica dentro do carrinho, que esta display:none, por isso o BLIK saia
     branco. Aqui os ids sao tornados unicos em cada instancia. */
  function fixGradients(scope) {
    var svgs = scope.querySelectorAll('svg');
    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      if (svg.dataset.jwIds === '1') continue;
      svg.dataset.jwIds = '1';
      var defs = svg.querySelectorAll('[id]');
      for (var j = 0; j < defs.length; j++) {
        var oldId = defs[j].getAttribute('id');
        if (!oldId || oldId.indexOf('pi-') !== 0) continue;
        var newId = oldId + '-jw' + i + j;
        defs[j].setAttribute('id', newId);
        var users = svg.querySelectorAll('[fill], [stroke], [filter], [clip-path]');
        for (var k = 0; k < users.length; k++) {
          ['fill', 'stroke', 'filter', 'clip-path'].forEach(function (attr) {
            var v = users[k].getAttribute(attr);
            if (v && v.indexOf('#' + oldId + ')') > -1) {
              users[k].setAttribute(attr, v.replace('#' + oldId + ')', '#' + newId + ')'));
            }
          });
        }
      }
    }
  }

  /* Linha de avaliacoes: fica dentro de .product__head, mesmo por cima
     do titulo, tal como na loja de referencia.
     A classe e .jw-rating (e nao .jw-stars) para nao chocar com as
     estrelas da seccao de avaliacoes, que ja usam .jw-stars. */
  function addRating() {
    var heads = document.querySelectorAll('.form__width .product__head');
    for (var i = 0; i < heads.length; i++) {
      var head = heads[i];
      if (head.querySelector(':scope > .jw-rating')) continue;
      var titleWrap = head.querySelector('.product__title__wrapper');
      if (!titleWrap || !head.querySelector('h1.product__title')) continue;

      var line = document.createElement('div');
      line.className = 'jw-rating';
      line.innerHTML =
        '<span class="jw-rating__icons" aria-hidden="true">★★★★★</span>' +
        RATING + ' ' + REVIEWS;
      head.insertBefore(line, titleWrap);
    }
  }

  function build() {
    addRating();

    var wraps = document.querySelectorAll('.form__width');
    for (var w = 0; w < wraps.length; w++) {
      var wrap = wraps[w];
      var pay = wrap.querySelector('.payment-icons');
      if (pay) fixGradients(pay);

      if (wrap.dataset.jwPdp === '1') continue;

      var buttons = wrap.querySelector('.product__block--buttons');
      if (!buttons) continue;
      wrap.dataset.jwPdp = '1';

      var anchor = buttons;

      var ship = document.createElement('div');
      ship.className = 'jw-ship';
      /* A bandeira e desenhada em CSS (.jw-flag): o emoji da bandeira da
         Polonia nao e suportado no Windows e aparece so como "PL". */
      ship.innerHTML =
        '<span class="jw-ship__left"><span class="jw-ship__dot"></span>' +
        'Wysyłka ' + shipDate() + '</span>' +
        '<span class="jw-ship__right">' +
        '<span class="jw-flag" role="img" aria-label="Polska"></span>' +
        'Darmowa dostawa</span>';
      anchor.parentNode.insertBefore(ship, anchor.nextSibling);
      anchor = ship;

      if (pay) {
        anchor.parentNode.insertBefore(pay, anchor.nextSibling);
        anchor = pay;
      }

      var notice = document.createElement('div');
      notice.className = 'jw-notice';
      notice.innerHTML =
        'AKTUALIZACJA: Z powodu wyprzedaży likwidacyjnej w Joanna Warszawa ' +
        'zapasy nie będą już uzupełniane. Jeśli przycisk „Dodaj do koszyka” ' +
        'jest nadal aktywny, oznacza to, że produkt jest jeszcze dostępny!';
      anchor.parentNode.insertBefore(notice, anchor.nextSibling);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  window.addEventListener('load', build);
  setTimeout(build, 1200);
  setTimeout(build, 2500);
})();
